import { render, staticRenderFns } from "./AllVideoLectures.vue?vue&type=template&id=27c66760"
import script from "./AllVideoLectures.vue?vue&type=script&lang=js"
export * from "./AllVideoLectures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports